import styled from 'styled-components';

const StyledContainer = styled.div<{ $filled?: boolean; $error?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 60px;
	padding: 0 20px;
	border-radius: 10px;
	background-color: ${({ $filled, $error }) =>
		$error
			? 'rgba(239, 49, 36, 0.15)'
			: $filled
			? '#1782FF'
			: 'rgba(255, 255, 255, 0.05)'};
	border: 1px solid
		${({ $filled, $error }) =>
			$error
				? 'rgba(239, 49, 36, 0.5)'
				: $filled
				? '#1782FF'
				: 'rgba(255, 255, 255, 0.1)'};
	transition:
		background-color 0.3s ease,
		border-color 0.3s ease;
`;

const StyledDotsRow = styled.div<{ $length: number }>`
	display: grid;
	grid-template-columns: repeat(${({ $length }) => $length}, 12px);
	gap: 50px;
`;

const StyledDot = styled.div<{ $active?: boolean; $error?: boolean }>`
	width: 12px;
	height: 12px;
	border-radius: 12px;
	background-color: ${({ $active, $error }) =>
		$error ? '#EF3124' : $active ? '#FFFFFF' : 'rgba(255, 255, 255, 0.25)'};
	transition: background-color 0.3s ease;
`;

export { StyledContainer, StyledDot, StyledDotsRow };
